/* Shop by Motorcycle selector.

   Progressive enhancement only: every model link is already a real anchor in the
   server-rendered HTML, so with JavaScript off the page shows all brands and all
   models as one plain list of links. This script adds the brand -> model
   disclosure behaviour on top of that markup and never generates a destination. */
(function () {
  var init = function (root) {
    if (!root || root.dataset.initialized === 'true') return;

    root.dataset.initialized = 'true';
    root.classList.add('is-enhanced');

    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-bike-brand]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-bike-panel]'));
    var emptyState = root.querySelector('[data-bike-empty]');

    panels.forEach(function (panel) {
      panel.hidden = true;
    });

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var selectedBrand = button.dataset.bikeBrand;

        buttons.forEach(function (item) {
          var isSelected = item === button;
          item.classList.toggle('is-active', isSelected);
          item.setAttribute('aria-expanded', String(isSelected));
        });

        panels.forEach(function (panel) {
          var isSelected = panel.dataset.bikePanel === selectedBrand;
          panel.hidden = !isSelected;
          panel.classList.toggle('is-active', isSelected);
        });

        if (emptyState) emptyState.hidden = true;
      });
    });
  };

  var initAll = function (scope) {
    (scope || document).querySelectorAll('[data-bike-selector]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  /* Theme editor: re-run when a section carrying the selector is re-rendered. */
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
